
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help_center",
      function () {
        return require("private-next-pages/help_center/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help_center"])
      });
    }
  